import { IASIEntity } from "../../pages/client-hub-asi/components/model";
import { api } from "../../services/helpers";
import { HttpService } from "../http/HttpService";

const httpService = new HttpService(`${api}`);
const url = "sp-asi-devices";

export class ASIDeviceService {
  async create(payload: IASIEntity): Promise<any> {
    return await httpService.post(`/${url}`, payload);
  }

  async getList(hubId: string): Promise<any> {
    return await httpService.post(`/${url}/get-list`, { hubId });
  }

  async getAll(): Promise<any> {
    return await httpService.get(`/${url}`);
  }

  async getHubsOverview(): Promise<any[]> {
    return await httpService.get(`/${url}/hubs-overview`);
  }

  async getPublicList(hubId: string): Promise<any[]> {
    return await httpService.post(`/${url}/public-list`, { hubId });
  }

  async updateMeta(
    id: string,
    payload: { description?: string; comment?: string }
  ): Promise<any> {
    return await httpService.post(`/${url}/${id}/meta`, payload);
  }

  async getById(id: string): Promise<any> {
    return await httpService.get(`/${url}/${id}`);
  }

  async getPanelInfo(payload: any) {
    return await httpService.post(`/${url}/panel`, {
      hubId: payload.hubId,
      asiId: payload.asiId,
    });
  }

  async bindZonesToAsi(payload: any) {
    return await httpService.post(`/${url}/zones`, {
      asiId: payload.asiId,
      zoneIds: payload.zoneIds,
    });
  }

  async updateSchedule(
    asiId: string,
    schedule: {
      scheduleEnabled?: boolean;
      openSchedule?: {
        dayOfWeek: string;
        startTime: string;
        endTime: string;
      }[];
    }
  ): Promise<any> {
    return await httpService.post(`/${url}/${asiId}/schedule`, schedule);
  }

  async delete(id: string) {
    return await httpService.delete(`/${url}/${String(id)}`);
  }

  async updateOnlyCardOrFaceOrPassword(
    asiId: string,
    onlyCardOrFaceOrPassword: boolean
  ) {
    return await httpService.post(
      `/${url}/${asiId}/only-card-or-face-or-password`,
      { onlyCardOrFaceOrPassword }
    );
  }
}
